import { useState } from 'react';
import { AVAILABILITY } from '../mock';

const FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'trade', label: 'Trade' },
  { id: 'offices', label: 'Offices' },
];

const STATUS_CLASS = {
  Available: 'badge-available',
  'Under Offer': 'badge-under-offer',
  Let: 'badge-let',
};

function statusClass(status) {
  return STATUS_CLASS[status] || 'badge-let';
}

export default function Availability() {
  const [filter, setFilter] = useState('all');

  const rows = AVAILABILITY.filter((r) => filter === 'all' || r.category === filter);

  return (
    <section id="availability" className="bg-[#e9e3d6] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div className="max-w-2xl">
            <span className="eyebrow">Availability</span>
            <h2 className="font-serif-display text-[42px] md:text-[54px] leading-[1.05] mt-6">
              Find your<br />
              <em className="text-[#b39352] italic">next space.</em>
            </h2>
            <p className="mt-6 text-[14px] leading-[1.85] text-[#0d281e]/80 max-w-xl">
              Flexible lease terms across trade counter, light industrial and office suites — from 450 sq
              ft to 2,100+ sq ft.
            </p>
          </div>
          <div className="flex items-center gap-2 border border-[#0d281e]/15 p-1">
            {FILTERS.map((f) => (
              <button
                key={f.id}
                onClick={() => setFilter(f.id)}
                className={`tab-pill ${filter === f.id ? 'active' : ''}`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-14 hidden md:grid grid-cols-12 gap-4 pb-3 border-b border-[#0d281e]/20">
          <div className="col-span-2 eyebrow !text-[#0d281e] !before:hidden" style={{ color: '#0d281e' }}>
            <span className="text-[10px] tracking-[0.22em] uppercase text-[#0d281e]/80">Unit</span>
          </div>
          <div className="col-span-2"><span className="text-[10px] tracking-[0.22em] uppercase text-[#0d281e]/80">Type</span></div>
          <div className="col-span-2"><span className="text-[10px] tracking-[0.22em] uppercase text-[#0d281e]/80">Size</span></div>
          <div className="col-span-3"><span className="text-[10px] tracking-[0.22em] uppercase text-[#0d281e]/80">Description</span></div>
          <div className="col-span-2"><span className="text-[10px] tracking-[0.22em] uppercase text-[#0d281e]/80">Status</span></div>
          <div className="col-span-1 text-right"><span className="text-[10px] tracking-[0.22em] uppercase text-[#0d281e]/80">Action</span></div>
        </div>

        <div>
          {rows.map((r) => (
            <div key={r.unit} className="avail-row grid grid-cols-1 md:grid-cols-12 gap-4 py-6 items-center">
              <div className="col-span-2 font-serif-display text-[22px] text-[#0d281e]">{r.unit}</div>
              <div className="col-span-2 text-[13px] text-[#0d281e]/80">{r.type}</div>
              <div className="col-span-2 text-[#0d281e]">
                <span className="font-serif-display text-[26px]">{r.size}</span>
                <span className="text-[11px] ml-1 text-[#0d281e]/60">sq ft</span>
              </div>
              <div className="col-span-3 text-[13px] text-[#0d281e]/80 leading-relaxed">{r.desc}</div>
              <div className="col-span-2">
                <span className={statusClass(r.status)}>{r.status}</span>
              </div>
              <div className="col-span-1 md:text-right">
                {r.status === 'Let' ? (
                  <span className="text-[#0d281e]/40">—</span>
                ) : (
                  <a
                    href="#enquire"
                    className="text-[10px] tracking-[0.22em] uppercase text-[#0d281e] hover:text-[#b39352] border-b border-[#b39352] pb-0.5 transition-colors"
                  >
                    Enquire
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
